module.exports = __webpack_public_path__ + "static/Picard-7a97557719cacdfde100a5807a5b9785.png";